import { render } from "./RulesText.vue?vue&type=template&id=fc360b3c"
import script from "./RulesText.vue?vue&type=script&lang=js"
export * from "./RulesText.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\game\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__